import React from 'react';
import { Upload, X } from 'lucide-react';

const SiteImagesTab = ({ 
  siteImages, 
  setSiteImages, 
  handleImageUpload, 
  uploading, 
  handleSiteImagesSubmit, 
  isSubmitting 
}) => {
  const imageCategories = [
    { key: 'hero_background_image', label: 'Фоновое изображение главной страницы', description: 'Основное фоновое изображение для главной страницы' },
    { key: 'about_image', label: 'Портрет для страницы "О нас"', description: 'Портретное изображение для страницы "О нас"' },
    { key: 'portfolio_category_image', label: 'Изображение категории портфолио', description: 'Изображение для раздела портфолио' },
    { key: 'services_category_image', label: 'Изображение категории услуг', description: 'Изображение для раздела услуг' },
    { key: 'reviews_category_image', label: 'Изображение категории отзывов', description: 'Изображение для раздела отзывов' },
    { key: 'blog_category_image', label: 'Изображение категории блога', description: 'Изображение для раздела блога' },
    { key: 'contacts_category_image', label: 'Изображение категории контактов', description: 'Изображение для раздела контактов' },
    { key: 'booking_category_image', label: 'Изображение категории бронирования', description: 'Изображение для раздела бронирования' }
  ];

  return (
    <form onSubmit={handleSiteImagesSubmit} className="space-y-6">
      <h3 className="text-lg font-medium text-white">Управление изображениями сайта</h3>
      <p className="text-gray-400 text-sm">Загружайте и управляйте изображениями, используемыми на всем вашем веб-сайте. Изменения появятся сразу после сохранения.</p>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {imageCategories.map((category) => (
          <div key={category.key} className="space-y-4">
            <label className="block text-sm font-medium text-gray-300">
              {category.label}
            </label>
            <p className="text-xs text-gray-400">{category.description}</p>
            <div className="space-y-3">
              {siteImages[category.key] && (
                <div className="relative group">
                  <img 
                    src={siteImages[category.key]} 
                    alt={category.label} 
                    className="w-full h-32 object-cover rounded-md border border-gray-600"
                  />
                  <button
                    type="button"
                    onClick={() => setSiteImages(prev => ({...prev, [category.key]: ''}))}
                    className="absolute top-2 right-2 bg-red-600 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                  >
                    <X className="h-4 w-4" />
                  </button>
                </div>
              )}
              <div className="flex items-center space-x-3">
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleImageUpload(category.key, e.target.files[0])}
                  className="hidden"
                  id={`${category.key}-upload`}
                  disabled={uploading === category.key}
                />
                <label 
                  htmlFor={`${category.key}-upload`}
                  className="flex items-center px-3 py-2 bg-gray-700 border border-gray-600 text-white rounded-md cursor-pointer hover:bg-gray-600 disabled:opacity-50"
                >
                  {uploading === category.key ? (
                    <>Загрузка...</>
                  ) : (
                    <>
                      <Upload className="h-4 w-4 mr-2" />
                      Загрузить {category.label}
                    </>
                  )}
                </label>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="flex justify-end">
        <button
          type="submit"
          disabled={isSubmitting}
          className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:opacity-50 transition-colors duration-200"
        >
          {isSubmitting ? 'Сохранение...' : 'Сохранить изображения сайта'}
        </button>
      </div>
    </form>
  );
};

export default SiteImagesTab;